import { AccessRequestsScopeModel, AccessStatus } from '@apono/client-app-sdk';

import { NoResults } from '@common/ui/NoResults';
import { Loader } from '@common/ui/Loader';
import useRequestsTable from '@common/hooks/use-requests-table';

import TasksTable from '../organisms/TasksTable';

export default function TasksPage() {
  const { isFetched, isLoading, pageData, selectedRequestId, handleRequestClick, handleOnPageChange } =
    useRequestsTable({
      statuses: [AccessStatus.Pending, AccessStatus.PENDING],
      scope: AccessRequestsScopeModel.MyTasks,
      refetch: 10 * 1000,
    });

  if (!isFetched) {
    return <Loader />;
  }

  if (!pageData || pageData.data.length === 0) {
    return <NoResults>No tasks found</NoResults>;
  }

  return <TasksTable {...{ isLoading, pageData, selectedRequestId, handleRequestClick, handleOnPageChange }} />;
}
